import { render, staticRenderFns } from "./ChoosePlatform.vue?vue&type=template&id=123b2e27&scoped=true"
import script from "./ChoosePlatform.vue?vue&type=script&lang=js"
export * from "./ChoosePlatform.vue?vue&type=script&lang=js"
import style0 from "./ChoosePlatform.vue?vue&type=style&index=0&id=123b2e27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123b2e27",
  null
  
)

export default component.exports